import {Deserializable} from '../deserializable';
import {Calendar} from './calendar';
export  class CalendarWeek implements Deserializable
{
  public week: number;
  public day: number;
  public dateWeek: String;
  public calendars: Calendar[];
  deserialize(input: any): this {
    Object.assign(this, input);
    this.calendars = input.calendars.map(calendars => new Calendar().deserialize(calendars));
    return this;
  }
}
